import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  SupplierAllocation,
  SupplierAllocationsParams,
  SupplierAllocationsUpdate,
} from '@ps/survey-utils';

export const SupplierActions = createActionGroup({
  source: 'Survey Supplier',
  events: {
    'Load Allocations': props<{
      surveyId: number;
      params: SupplierAllocationsParams;
    }>(),
    'Update Allocations': props<{
      surveyId: number;
      update: SupplierAllocationsUpdate;
    }>(),
    'Reset Allocations': emptyProps(),
  },
});

export const SupplierApiActions = createActionGroup({
  source: 'Survey Supplier API',
  events: {
    'Load Allocations Success': props<{
      allocations: SupplierAllocation[];
    }>(),
    'Load Allocations Failure': props<{ error: string }>(),
    /**
     * Deliberately distinct from `Load Allocations Success` even though the PUT
     * returns the same shape: the survey-creation recalculation effect both
     * emits the load event and listens for this one, so sharing a single action
     * would make it retrigger itself.
     */
    'Update Allocations Success': props<{
      allocations: SupplierAllocation[];
    }>(),
    'Update Allocations Failure': props<{ error: string }>(),
  },
});
